/**
 * Converts an aspect ratio string like "4:3" to a CSS style object.
 * Returns an empty object for invalid inputs.
 */
export function aspectRatioToStyle(
	ratio: string | undefined | null,
	fallback?: string,
): React.CSSProperties {
	const value = ratio || fallback;
	if (!value) return {};
	const parts = value.split(":");
	if (parts.length !== 2) return {};
	const w = Number(parts[0]);
	const h = Number(parts[1]);
	if (!w || !h) return {};
	return { aspectRatio: `${w} / ${h}` };
}
